import { useContext } from 'react';

import { TaskDetailActionsContext } from './task-detail-context';

export const useOpenCreateTask = () => {
  const { openCreateTask } = useContext(TaskDetailActionsContext);

  return openCreateTask;
};
